import { useParams } from 'react-router-dom';

// Install fallback for the App Link https://app.linkr.fyi/restore/<slug>.
// Verified Android installs intercept this URL before the page loads, so users
// who see this page DON'T have the app yet (or the link wasn't verified).
// iOS deferred Universal Links don't survive a fresh install — iOS users may
// need to re-scan the QR after installing.
export default function Restore() {
  const { slug } = useParams<{ slug: string }>();
  // Android Play install referrer carries the slug through to first launch,
  // where DeepLinkHandler reads it and routes into UpgradeScreen.
  const playUrl = `https://play.google.com/store/apps/details?id=com.linkr.qrcodes&referrer=${encodeURIComponent(
    `slug=${slug ?? ''}`
  )}`;
  // App Store URL is a placeholder until the iOS app ships.
  const appStoreUrl = 'https://linkr.fyi/get';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="max-w-md w-full bg-white rounded-2xl border border-gray-200 p-8 text-center">
        <div className="text-3xl font-semibold tracking-tight mb-2">
          link<span className="text-blue-500">r</span>
        </div>
        <p className="text-gray-600 mb-6">Restore this code</p>

        <p className="text-sm text-gray-700 mb-6 leading-relaxed">
          Get the app to take over QR code{' '}
          <span className="font-mono text-gray-900">{slug ?? '—'}</span>. After install, open
          the app to upgrade and remove the redirect page.
        </p>

        <div className="flex flex-col gap-3">
          <a
            href={playUrl}
            className="inline-block bg-gray-900 text-white rounded-lg py-3 px-4 text-sm font-medium hover:bg-gray-700"
          >
            Get it on Google Play
          </a>
          <a
            href={appStoreUrl}
            className="inline-block bg-gray-100 text-gray-900 rounded-lg py-3 px-4 text-sm font-medium hover:bg-gray-200"
          >
            Download on the App Store
          </a>
        </div>

        <p className="text-xs text-gray-400 mt-6">
          Already have the app? Open it and pick this code from the home screen.
        </p>
      </div>
    </div>
  );
}
